/**
 * Builds the `invitations_dropdown_opened` event fired when the header
 * envelope icon opens its menu — same "click always means open" reasoning
 * as notificationsDropdownOpened.ts.
 */

import { getSessionId } from "./session";
import type { InvitationsDropdownOpenedEvent } from "./types";

export const buildInvitationsDropdownOpenedEvent = (
  inviteCount: number,
): InvitationsDropdownOpenedEvent => ({
  name: "invitations_dropdown_opened",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: { invite_count: inviteCount },
});
